import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const registrationstepGuard: CanActivateFn = (route, state) => {
  // Get the Router instance (injected functionally)
  const router = inject(Router);

  // Get the current URL (to know which route the user is trying to access)
  const currentUrl = state.url;

  // Function to check if the previous step was completed
  const checkPreviousStep = (url: string): boolean => {
    switch (url) {
      case '/register':
        return !!sessionStorage.getItem('registerUserAsCompleted');
      case '/msmeuserverification':
        return !!sessionStorage.getItem('registerCompleted');
      case '/contactdetails':
        return !!sessionStorage.getItem('msmeuserVerificationCompleted');
      case '/credentialdetails':
        return !!sessionStorage.getItem('contactDetailsCompleted');
      case '/personaldetails':
        return !!sessionStorage.getItem('credentialDetailsCompleted');
      case '/msmepreviewpage':
        return !!sessionStorage.getItem('personalDetailsCompleted');

      case '/eoi':
        return !!sessionStorage.getItem('EOIOtpVerified');
      case '/eoiinvitation':
        return !!sessionStorage.getItem('EOIInvitation');
      case '/eoiverification':
        return !!sessionStorage.getItem('EOIVerification');
      case '/eoiotpverification':
        return !!sessionStorage.getItem('EOIOTPVerification');
      default:
        return true; // Allow access to the first page (e.g., /register)
    }
  };

  // Function to get the previous step's route to redirect the user
  const getPreviousStep = (url: string): string => {
    switch (url) {
      case '/register':
        return '/registeruseras';
      case '/msmeuserverification':
        return '/register';
      case '/contactdetails':
        return '/msmeuserverification';
      case '/credentialdetails':
        return '/contactdetails';
      case '/personaldetails':
        return '/credentialdetails';
      case '/msmepreviewpage':
        return '/personaldetails';
      default:
        return '/login';  // Default to the first page if the URL doesn't match
    }
  };  

  // Check if the user has completed the previous step
  const previousStepCompleted = checkPreviousStep(currentUrl);

  if (!previousStepCompleted) {
    // If the previous step is not completed, redirect to the previous step
    router.navigate([getPreviousStep(currentUrl)]);
    return false;  // Prevent access to the current route
  }

  return true;  // Allow access to the current route if the previous step is completed
};
